<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="4,3,2"></start-end>
      </div>
      <div class="formTableItem">
        <p class="label">选择车辆</p>
        <selecAlotCCar
          ref="selecAlotCCar"
          @carIdList="searchItem.carIdList = $event"
        ></selecAlotCCar>
      </div>
      <div class="formTableItem">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="chaxun" type="primary" class="chaxun10">查询</Button>
        <Button @click="openAdd" class="chaxun">新增</Button>
        <Button @click="daoru" class="chaxun">导入</Button>
        <Button @click="exportAll" class="chaxun">导出</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="proofList">
        <viewer v-if="row.filesArr.length > 0">
          <img
            v-for="(x, index) in row.filesArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增记录' : '编辑记录'"
      width="700"
      ref="formModel"
    >
      <Input
        v-model="item.ono"
        placeholder="请选择"
        slot="ono"
        @on-focus="openForm = true"
        readonly
      ></Input>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Modal
      v-model="openForm"
      fullscreen
      title="订单号"
      footer-hide
      width="1000"
    >
      <shangmentihuoListVue
        :scan="true"
        :checkMore="false"
        :status="[]"
        @obj="reObj"
        v-if="openForm"
      ></shangmentihuoListVue>
    </Modal>
  </div>
</template>
<script>
import shangmentihuoListVue from "../wuliu/fahuo/shangmentihuoList.vue";
import dingdanhao from "../wuliu/fahuo/xitongkaidanSortDe.vue";

export default {
  components: { dingdanhao, shangmentihuoListVue },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "单位名称",
          key: "groupName",
          sort: 2,
        },

        {
          title: "操作",
          slot: "action",
          sort: 200,
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        ono: "",
        carId: 0,
        carNo: "",
        type: "",
        driverAccount: "",
        driver: "",
        files: "",
        filesArr: "",
        money: 0,
        payDate: "",
        remark: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startTime: 0,
        endTime: 0,
        carIdList: [],
        status: 3, //statue：1-审核，2-撤销。3-通过，
      },
      total: 0,
      openForm: false,
      forms: [
        {
          title: "订单号",
          key: "ono",
          slotForm: "ono",
          multiple: true,
          required: true,
        },
        {
          title: "车牌号",
          key: "carId",
          key1: "carNo",
          type: "selectCar",
          required: true,
        },
        {
          title: "司机",
          key4: "driverAccount",
          key1: "driver",
          type: "selectUser",
          required: true,
        },
        {
          title: "费用类型",
          key: "type",
          type: "Select",
          selectItems: this.lydic.getA("costType"),
          required: true,
        },
        {
          title: "金额",
          key: "money",
          type: "InputNumber",
        },
        {
          title: "日期",
          key: "payDate",
          key2: "payDate2",
          type: "lyyymmdd",
          required: true,
        },
        {
          title: "图片",
          key: "filesArr",
          slot: "proofList",
          type: "lyPhoto",
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 24,
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-rpt/integratedCost/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].payDate2 = this.utils.time(data[i].payDate, "yymmdd");
          data[i].filesArr = this.utils.isEmpty(data[i].files)
            ? []
            : JSON.parse(data[i].files);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item.files = JSON.stringify(this.item.filesArr);

      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-rpt/integratedCost/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-rpt/integratedCost/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-rpt/integratedCost/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    exportAll() {
      var params = [
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
      ];
      this.utils.exportData(this.axios.cost + "/care/export", params);
    },
    daoru() {
      this.$Message.info("开发中");
    },
    reObj(v) {
      this.item.ono = v.ono;
      this.openForm = false;
    },
  },
  mounted() {
    var config = {
      min: 150,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/pay/integratedCost.vue